// import { useState, useEffect } from "react";
// import { HandySvg } from "handy-svg";
// import { PhotoProvider, PhotoView } from "react-photo-view";
// import addToCart from "../../function/addToCard";
// import iconSrc from "../../svg/arrowLeft.svg";
// import arrow from "../../svg/arrow.svg";
// import iconSrcWhite from "../../svg/smallProductLike.svg";
// import iconSrcCardWhite from "../../svg/smallProductCard.svg";
// import withFieldData from "../HOK/withFieldData";
// import "./mainPage.css";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { addFilter } from "../../function/filtersSlice";
// import { Link } from "react-router-dom";
// import transliterate from "../../function/transliterate";
// import { findAuthorByName } from "./getAuthorLink";
// import { getProductHref } from "../../function/productLink";
// const NewBooks = ({ products, setCartCounterC, setLikeCounterC }) => {
//   const [selectedProductIndex, setSelectedProductIndex] = useState(0);
//   const [currentProduct, setCurrentProduct] = useState(null);
//   const [liked, setLiked] = useState(false);
//   const [startX, setStartX] = useState(null);
//   const [endX, setEndX] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [authorLinkData, setAuthorLinkData] = useState(null);
//   const [picWriterLinkData, setPicWriterLinkData] = useState(null);
//   useEffect(() => {
//     const fetchPicWriter = async () => {
//       const result = await findAuthorByName(currentProduct?.picWriter);
//       setPicWriterLinkData(result);
//     };
//     if (currentProduct?.picWriter) {
//       fetchPicWriter();
//     }
//   }, [currentProduct?.picWriter]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const goToNew = () => {
//     dispatch(addFilter({ field: "isNew", value: "true" }));
//     navigate("/catalog");
//   };

//   // const handleNextBook = () => {
//   //   setSelectedProductIndex((prevIndex) =>
//   //     prevIndex < products.length - 1 ? prevIndex + 1 : prevIndex
//   //   );
//   // };
//   const handleNextBook = () => {
//     setSelectedProductIndex((prevIndex) =>
//       prevIndex < products.length - 1 ? prevIndex + 1 : 0,
//     );
//   };

//   // const handlePrevBook = () => {
//   //   setSelectedProductIndex((prevIndex) =>
//   //     prevIndex > 0 ? prevIndex - 1 : prevIndex
//   //   );
//   // };
//   const handlePrevBook = () => {
//     setSelectedProductIndex((prevIndex) =>
//       prevIndex > 0 ? prevIndex - 1 : products.length - 1,
//     );
//   };

//   useEffect(() => {
//     setCurrentProduct(products[selectedProductIndex]);
//   }, [products, selectedProductIndex]);

//   // Обробка свайпу (мобільні пристрої)
//   const handleTouchStart = (e) => {
//     setStartX(e.touches[0].clientX);
//   };

//   const handleTouchMove = (e) => {
//     setEndX(e.touches[0].clientX);
//   };

//   const handleTouchEnd = () => {
//     if (startX && endX) {
//       const swipeDistance = startX - endX;
//       if (swipeDistance > 50) {
//         handleNextBook();
//       } else if (swipeDistance < -50) {
//         handlePrevBook();
//       }
//     }
//     setStartX(null);
//     setEndX(null);
//   };

//   // Обробка свайпу (десктоп, мишка)
//   const handleMouseDown = (e) => {
//     setStartX(e.clientX);
//     setIsDragging(true);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setEndX(e.clientX);
//     }
//   };

//   const handleMouseUp = () => {
//     if (startX && endX) {
//       const swipeDistance = startX - endX;
//       if (swipeDistance > 50) {
//         handleNextBook();
//       } else if (swipeDistance < -50) {
//         handlePrevBook();
//       }
//     }
//     setStartX(null);
//     setEndX(null);
//     setIsDragging(false);
//   };
//   useEffect(() => {
//     const fetchAuthor = async () => {
//       const result = await findAuthorByName(currentProduct?.textAutor);
//       setAuthorLinkData(result);
//     };
//     if (currentProduct?.textAutor) {
//       fetchAuthor();
//     }
//   }, [currentProduct?.textAutor]);
//   const handleLike = () => {
//     let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];
//     if (!liked) {
//       setLikeCounterC((prev) => prev + 1);
//       likedProducts.push(currentProduct);
//     } else {
//       likedProducts = likedProducts.filter(
//         (product) => product.uid !== currentProduct.uid,
//       );
//       setLikeCounterC((prev) => prev - 1);
//     }
//     localStorage.setItem("likedProducts", JSON.stringify(likedProducts));
//     setLiked(!liked);
//   };

//   const addingToCart = (id) => {
//     addToCart(id);
//     setCartCounterC((prev) => prev + 1);
//   };

//   return (
//     <div
//       className="newBooksWrapBlock"
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//     >
//       {currentProduct && (
//         <>
//           <div className="yellowBorderWrap">
//             <div className="imgPictureBox">
//               <PhotoProvider>
//                 <PhotoView src={currentProduct.imageList[0]}>
//                   <img
//                     src={currentProduct.imageList[0]}
//                     alt={currentProduct.bookName}
//                     className="productBigPictureImg"
//                   />
//                 </PhotoView>
//                 {currentProduct.imageList.map((item, index) => (
//                   <PhotoView key={index} src={item}>
//                     <span style={{ display: "none" }} />
//                   </PhotoView>
//                 ))}
//               </PhotoProvider>
//               <div className="markerNew">Новинка</div>
//             </div>
//             <HandySvg
//               onClick={handlePrevBook}
//               className="arrowLeft"
//               src={iconSrc}
//               width="42"
//               height="40"
//             />
//           </div>
//           <div className="blueBorderWrap">
//             <div className="infoPredProdagNewBooks">
//               <h1
//                 className="nameBooksNewBooks"
//                 onClick={goToNew}
//                 style={{ cursor: "pointer" }}
//               >
//                 Новинка
//               </h1>

//               {/* <h2 className="nameBooksNew">{currentProduct.bookName}</h2> */}
//               <Link
//                 to={getProductHref(currentProduct)}
//                 className="nameBooksNew"
//                 onClick={() => {
//                   let visited =
//                     JSON.parse(localStorage.getItem("visitedProducts")) || [];
//                   if (!visited.includes(currentProduct.uid)) {
//                     visited.push(currentProduct.uid);
//                     localStorage.setItem(
//                       "visitedProducts",
//                       JSON.stringify(visited),
//                     );
//                   }
//                 }}
//               >
//                 {currentProduct.bookName}
//               </Link>

//               <div className="autorInformNew">
//                 <div className="wrapInFgAuthQW">
//                   <div className="autorInformSection">
//                     <p>Автор:&nbsp;</p>
//                     {/* <h4>{currentProduct.textAutor}</h4> */}
//                     {authorLinkData ? (
//                       <Link
//                         className="autorInformSectionWia"
//                         to={`/author/${authorLinkData.uid}`}
//                       >
//                         {currentProduct.textAutor}
//                       </Link>
//                     ) : (
//                       <h4>{currentProduct.textAutor}</h4>
//                     )}
//                   </div>
//                   <div className="autorInformSection">
//                     <p>Художник:&nbsp;</p>
//                     {picWriterLinkData ? (
//                       <Link
//                         className="autorInformSectionWia"
//                         to={`/author/${picWriterLinkData.uid}`}
//                       >
//                         {currentProduct.picWriter}
//                       </Link>
//                     ) : (
//                       <h4>{currentProduct.picWriter}</h4>
//                     )}
//                   </div>
//                 </div>
//                 <div className="autorInformSectionTwo">
//                   <p>Вік:&nbsp;</p>
//                   <h4>{currentProduct.yearGroup.join(", ")}</h4>
//                 </div>
//               </div>
//               <p className="descriptionBooksNew">
//                 {currentProduct.descriptionSe}
//               </p>
//               <div className="blockOrderBooksWrap">
//                 <div className="prodPricLikeCartNovun">
//                   <div className="prdeProdPricingCartSale">
//                     <div className="prdeProdPricingRotateCart">
//                       <p className="salePriceCartSale">
//                         {currentProduct.price}
//                       </p>
//                       <p className="fullPriceCartG">грн</p>
//                     </div>
//                   </div>
//                   <div className="likeCardWrapSmall">
//                     <div
//                       className="likeProductSmallSaleNovu"
//                       onClick={() => addingToCart(currentProduct.uid)}
//                     >
//                       <HandySvg
//                         src={iconSrcCardWhite}
//                         width="28.33"
//                         height="28.33"
//                       />
//                     </div>
//                     <div
//                       className={`likeProductSmallSaleNovuGr${
//                         liked ? "Click" : ""
//                       }`}
//                       onClick={handleLike}
//                     >
//                       <HandySvg src={iconSrcWhite} width="34" height="31" />
//                     </div>
//                   </div>
//                 </div>

//                 <HandySvg
//                   onClick={handleNextBook}
//                   src={arrow}
//                   className="arrovIconBanner"
//                   width="52"
//                   height="49.56"
//                 />
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default withFieldData("isNew", "product", "true")(NewBooks);

import { useState, useEffect } from "react";
import { HandySvg } from "handy-svg";
import { PhotoProvider, PhotoView } from "react-photo-view";
import addToCart from "../../function/addToCard";
import iconSrc from "../../svg/arrowLeft.svg";
import arrow from "../../svg/arrow.svg";
import iconSrcWhite from "../../svg/smallProductLike.svg";
import iconSrcCardWhite from "../../svg/smallProductCard.svg";
import withFieldData from "../HOK/withFieldData";
import "./mainPage.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addFilter } from "../../function/filtersSlice";
import { Link } from "react-router-dom";
import transliterate from "../../function/transliterate";
import { findAuthorByName } from "./getAuthorLink";
import { getProductHref } from "../../function/productLink";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
const NewBooks = ({ products, setCartCounterC, setLikeCounterC }) => {
  const [selectedProductIndex, setSelectedProductIndex] = useState(0);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [liked, setLiked] = useState(false);
  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [authorLinkData, setAuthorLinkData] = useState(null);
  const [picWriterLinkData, setPicWriterLinkData] = useState(null);
  useEffect(() => {
    const fetchPicWriter = async () => {
      const result = await findAuthorByName(currentProduct?.picWriter);
      setPicWriterLinkData(result);
    };
    if (currentProduct?.picWriter) {
      fetchPicWriter();
    }
  }, [currentProduct?.picWriter]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToNew = () => {
    dispatch(addFilter({ field: "isNew", value: "true" }));
    navigate("/catalog");
  };

  // const handleNextBook = () => {
  //   setSelectedProductIndex((prevIndex) =>
  //     prevIndex < products.length - 1 ? prevIndex + 1 : prevIndex
  //   );
  // };
  const handleNextBook = () => {
    setSelectedProductIndex((prevIndex) =>
      prevIndex < products.length - 1 ? prevIndex + 1 : 0,
    );
  };

  // const handlePrevBook = () => {
  //   setSelectedProductIndex((prevIndex) =>
  //     prevIndex > 0 ? prevIndex - 1 : prevIndex
  //   );
  // };
  const handlePrevBook = () => {
    setSelectedProductIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : products.length - 1,
    );
  };

  useEffect(() => {
    setCurrentProduct(products[selectedProductIndex]);
  }, [products, selectedProductIndex]);
  useEffect(() => {
    const checkDiscountsForProduct = async () => {
      const product = products[selectedProductIndex];

      if (!product) return;

      let updatedProduct = { ...product };
      const now = new Date();

      try {
        // 1. Перевірка actions
        const snapshotActions = await getDocs(collection(db, "actions"));
        const actions = snapshotActions.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const matchedAction = actions.find((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = action.endDate ? new Date(action.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const applies = action.appliesTo || {};

          const matchProduct =
            Array.isArray(applies.products) &&
            applies.products.some(
              (pid) => pid === product.uid || pid === product.id,
            );

          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
              ? [product.seria]
              : Array.isArray(product.series)
                ? product.series
                : typeof product.series === "string" && product.series !== ""
                  ? [product.series]
                  : [];

          const matchSeries =
            Array.isArray(applies.series) &&
            productSeries.some((ser) => applies.series.includes(ser));

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];

          const actionAuthors = Array.isArray(applies.authors)
            ? applies.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            actionAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });

        if (matchedAction) {
          const discount = Number(matchedAction.discountPercent) || 0;
          const newPrice = Math.round(
            Number(product.price) - (Number(product.price) * discount) / 100,
          );

          updatedProduct = {
            ...updatedProduct,
            actionDiscountPercent: discount,
            actionPrice: newPrice,
          };
        }

        // 2. Перевірка sales
        const snapshotSales = await getDocs(collection(db, "sales"));
        const sales = snapshotSales.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const matchedSale = sales.find((sale) => {
          const start = sale.startDate ? new Date(sale.startDate) : null;
          const end = sale.endDate ? new Date(sale.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const applies = sale.appliesTo || {};

          const matchProduct =
            Array.isArray(applies.products) &&
            applies.products.some(
              (pid) => pid === product.uid || pid === product.id,
            );

          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
              ? [product.seria]
              : Array.isArray(product.series)
                ? product.series
                : typeof product.series === "string" && product.series !== ""
                  ? [product.series]
                  : [];

          const matchSeries =
            Array.isArray(applies.series) &&
            productSeries.some((ser) => applies.series.includes(ser));

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];

          const saleAuthors = Array.isArray(applies.authors)
            ? applies.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            saleAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });

        if (matchedSale) {
          const discount = Number(matchedSale.discountPercent) || 0;
          const newPrice = Math.round(
            Number(product.price) - (Number(product.price) * discount) / 100,
          );

          updatedProduct = {
            ...updatedProduct,
            saleDiscountPercent: discount,
            salePrice: newPrice,
          };
        }

        setCurrentProduct(updatedProduct);
      } catch (e) {
        console.error("Помилка при перевірці знижок у NewBooks:", e);
        setCurrentProduct(product);
      }
    };

    checkDiscountsForProduct();
  }, [products, selectedProductIndex]);
  // Обробка свайпу (мобільні пристрої)
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (startX && endX) {
      const swipeDistance = startX - endX;
      if (swipeDistance > 50) {
        handleNextBook();
      } else if (swipeDistance < -50) {
        handlePrevBook();
      }
    }
    setStartX(null);
    setEndX(null);
  };

  // Обробка свайпу (десктоп, мишка)
  const handleMouseDown = (e) => {
    setStartX(e.clientX);
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setEndX(e.clientX);
    }
  };

  const handleMouseUp = () => {
    if (startX && endX) {
      const swipeDistance = startX - endX;
      if (swipeDistance > 50) {
        handleNextBook();
      } else if (swipeDistance < -50) {
        handlePrevBook();
      }
    }
    setStartX(null);
    setEndX(null);
    setIsDragging(false);
  };
  useEffect(() => {
    const fetchAuthor = async () => {
      const result = await findAuthorByName(currentProduct?.textAutor);
      setAuthorLinkData(result);
    };
    if (currentProduct?.textAutor) {
      fetchAuthor();
    }
  }, [currentProduct?.textAutor]);
  const handleLike = () => {
    let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];
    if (!liked) {
      setLikeCounterC((prev) => prev + 1);
      likedProducts.push(currentProduct);
    } else {
      likedProducts = likedProducts.filter(
        (product) => product.uid !== currentProduct.uid,
      );
      setLikeCounterC((prev) => prev - 1);
    }
    localStorage.setItem("likedProducts", JSON.stringify(likedProducts));
    setLiked(!liked);
  };

  const addingToCart = (id) => {
    addToCart(id);
    setCartCounterC((prev) => prev + 1);
  };
  const productImages = Array.isArray(currentProduct?.imageList)
    ? currentProduct.imageList.filter(Boolean)
    : [];

  const productKey =
    currentProduct?.uid ||
    currentProduct?.id ||
    currentProduct?.bookName ||
    selectedProductIndex;
  const hasPriceSale =
    currentProduct?.priceSale && currentProduct.priceSale !== "";

  const oldPrice = hasPriceSale
    ? currentProduct.priceSale
    : currentProduct?.salePrice || currentProduct?.actionPrice
      ? currentProduct.price
      : null;

  const finalPrice = hasPriceSale
    ? currentProduct.price
    : currentProduct?.salePrice
      ? currentProduct.salePrice
      : currentProduct?.actionPrice
        ? currentProduct.actionPrice
        : currentProduct?.price;

  const hasDiscount = oldPrice && Number(oldPrice) !== Number(finalPrice);
  return (
    <div
      className="newBooksWrapBlock"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {currentProduct && (
        <>
          <div className="yellowBorderWrap">
            <div className="imgPictureBox">
              {/* <PhotoProvider>
                <PhotoView src={currentProduct.imageList[0]}>
                  <img
                    src={currentProduct.imageList[0]}
                    alt={currentProduct.bookName}
                    className="productBigPictureImg"
                  />
                </PhotoView>
                {currentProduct.imageList.map((item, index) => (
                  <PhotoView key={index} src={item}>
                    <span style={{ display: "none" }} />
                  </PhotoView>
                ))}
              </PhotoProvider> */}
              <PhotoProvider key={productKey}>
                {productImages.map((item, index) => (
                  <PhotoView key={`${productKey}-${item}-${index}`} src={item}>
                    {index === 0 ? (
                      <img
                        src={item}
                        alt={currentProduct.bookName}
                        className="productBigPictureImg"
                      />
                    ) : (
                      <span style={{ display: "none" }} />
                    )}
                  </PhotoView>
                ))}
              </PhotoProvider>
              <div className="markerNew">Новинка</div>
            </div>
            <HandySvg
              onClick={handlePrevBook}
              className="arrowLeft"
              src={iconSrc}
              width="42"
              height="40"
            />
          </div>
          <div className="blueBorderWrap">
            <div className="infoPredProdagNewBooks">
              <h1
                className="nameBooksNewBooks"
                onClick={goToNew}
                style={{ cursor: "pointer" }}
              >
                Новинка
              </h1>

              {/* <h2 className="nameBooksNew">{currentProduct.bookName}</h2> */}
              <Link
                to={getProductHref(currentProduct)}
                className="nameBooksNew"
                onClick={() => {
                  let visited =
                    JSON.parse(localStorage.getItem("visitedProducts")) || [];
                  if (!visited.includes(currentProduct.uid)) {
                    visited.push(currentProduct.uid);
                    localStorage.setItem(
                      "visitedProducts",
                      JSON.stringify(visited),
                    );
                  }
                }}
              >
                {currentProduct.bookName}
              </Link>

              <div className="autorInformNew">
                <div className="wrapInFgAuthQW">
                  <div className="autorInformSection">
                    <p>Автор:&nbsp;</p>
                    {/* <h4>{currentProduct.textAutor}</h4> */}
                    {authorLinkData ? (
                      <Link
                        className="autorInformSectionWia"
                        to={`/author/${authorLinkData.uid}`}
                      >
                        {currentProduct.textAutor}
                      </Link>
                    ) : (
                      <h4>{currentProduct.textAutor}</h4>
                    )}
                  </div>
                  <div className="autorInformSection">
                    <p>Художник:&nbsp;</p>
                    {picWriterLinkData ? (
                      <Link
                        className="autorInformSectionWia"
                        to={`/author/${picWriterLinkData.uid}`}
                      >
                        {currentProduct.picWriter}
                      </Link>
                    ) : (
                      <h4>{currentProduct.picWriter}</h4>
                    )}
                  </div>
                </div>
                <div className="autorInformSectionTwo">
                  <p>Вік:&nbsp;</p>
                  <h4>{currentProduct.yearGroup.join(", ")}</h4>
                </div>
              </div>
              <p className="descriptionBooksNew">
                {currentProduct.descriptionSe}
              </p>
              <div className="blockOrderBooksWrap">
                <div className="prodPricLikeCartNovun">
                  {/* <div className="prdeProdPricingCartSale">
                    <div className="prdeProdPricingRotateCart">
                      <p className="salePriceCartSale">
                        {currentProduct.price}
                      </p>
                      <p className="fullPriceCartG">грн</p>
                    </div>
                  </div> */}
                  <div
                    className={
                      hasDiscount
                        ? "prdeProdPricingCartSale prdeProdPricingCartSaleRed"
                        : "prdeProdPricingCartSale"
                    }
                  >
                    <div className="prdeProdPricingRotateCart">
                      {hasDiscount && (
                        <p className="fullPriceCartNewRforRed">{oldPrice}</p>
                      )}

                      <p
                        className={
                          hasDiscount
                            ? "salePriceCartNewForRed"
                            : "salePriceCartSale"
                        }
                      >
                        {finalPrice}
                      </p>

                      <p className="fullPriceCartG">грн</p>
                    </div>
                  </div>
                  <div className="likeCardWrapSmall">
                    <div
                      className="likeProductSmallSaleNovu"
                      onClick={() => addingToCart(currentProduct.uid)}
                    >
                      <HandySvg
                        src={iconSrcCardWhite}
                        width="28.33"
                        height="28.33"
                      />
                    </div>
                    <div
                      className={`likeProductSmallSaleNovuGr${
                        liked ? "Click" : ""
                      }`}
                      onClick={handleLike}
                    >
                      <HandySvg src={iconSrcWhite} width="34" height="31" />
                    </div>
                  </div>
                </div>

                <HandySvg
                  onClick={handleNextBook}
                  src={arrow}
                  className="arrovIconBanner"
                  width="52"
                  height="49.56"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default withFieldData("isNew", "product", "true")(NewBooks);
